import React from 'react';
import PropTypes from 'prop-types';

// import assets
import './textModule.scss';

const TextModuleView = props => (
  <div className="m-article-module">
    <div className={'m-text-module'} dangerouslySetInnerHTML={{ __html: props.children }} />
  </div>
);

TextModuleView.propTypes = {
  children: PropTypes.node,
};

TextModuleView.defaultProps = {
  children: null,
};

export default TextModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/TextModule/TextModuleView.jsx